import { API_V2 } from './apiVersion';

export const ATTENDANCE_ENDPOINTS = {
  ME: `${API_V2}/attendance/me`,
  RANKINGS: `${API_V2}/attendance/rankings`,
} as const;
